import { FC } from 'react';

import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { UlStyled } from './BrandPanelDetails.styles';

export const BrandPanelDetails: FC = () => (
	<>
		<MpParagraph>
			<MpText weight='bold'>Поддерживаемые браузеры:</MpText>
		</MpParagraph>
		<UlStyled>
			<li>Chrome: от v86</li>
			<li>Edge: от v90</li>
			<li>Opera: от v80</li>
		</UlStyled>
	</>
);
